import React, { createContext, useContext, useEffect, useState } from "react";
import api from '../utils/api'; ;

const RestaurantDetailsContext = createContext(null);

export const RestaurantDetailsProvider = ({ children }) => {
  const [restaurantDetails, setRestaurantDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // const restaurantId =
  //   localStorage.getItem("restaurantId") ||
  //   sessionStorage.getItem("restaurantId");

useEffect(() => {
  const fetchDetails = async () => {
    try {
      const cacheKey = "restaurantDetails";

      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        setRestaurantDetails(JSON.parse(cached));
      }

      const res = await api.get("/settings");

      if (res.data?.success) {
        setRestaurantDetails(res.data);
        localStorage.setItem(cacheKey, JSON.stringify(res.data));
      }
    } catch (err) {
      console.error("Failed to load restaurant details:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchDetails();
}, []);


  return (
    <RestaurantDetailsContext.Provider
      value={{ restaurantDetails, loading }}
    >
      {children}
    </RestaurantDetailsContext.Provider>
  );
};

export const useRestaurantDetails = () =>
  useContext(RestaurantDetailsContext);
